// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { filterListStyles } from "@eisinc/Overrides/Widgets/ProductList/ProductListFilterList";
import Eraser from "@eisinc/XDL/Icons/Eraser";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color, createLinkIconStyles } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

filterListStyles.innerWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 8px 4px;
        padding: 0 8px 8px;
    `,
};
filterListStyles.wrapper = {
    css: css`
        &:empty {
            display: none;
        }
    `,
};

filterListStyles.skipFiltersButtonWrapper = {
    css: css`
        position: relative;
        width: 100%;
    `,
};

filterListStyles.title = {
    size: fontConfig.singleLinexSmall.size,
    weight: fontConfig.weight.medium,
    lineHeight: fontConfig.singleLinexSmall.lineHeight,
    forwardAs: "p",
    css: css`
        background: ${color("common.ui2")};
        padding: 8px;
    `,
};

filterListStyles.clearAllLink = {
    ...createLinkIconStyles({
        icon: Eraser,
        sizeVariant: "small",
        linkStyles: {
            icon: {
                iconProps: {
                    ...({ width: 14, height: 13 } as any),
                },
            },
            css: css`
                width: 100%;
            `,
        },
    }),
};

filterListStyles.label = {
    weight: fontConfig.weight.regular,
};
